module.exports = function getResource(label, vars = []) {
    let resources = {
        unfollow: 'Ne plus suivre',
        follow: 'S’abonner',
        sendMessage: 'Envoyer un message'
    };
    return resources[label];
};
